const React = require('react');
const { MessagesHubModule} = require('messages-hub-realestates-lib');


const MHRealEstate = ({
  host,
  scope,
  userId,
  bu,
  siteId,
  categoryId,
  realestateId,
  domain,
}) => (

  <div className="messages-hub-realestate">
    <MessagesHubModule
      domain={domain}
      host={host}
      scope={scope}
      userId={userId}
      bu={bu}
      siteId={siteId}
      categoryId={categoryId}
      realestateId={realestateId}
    /></div>
);

module.exports = MHRealEstate;
